export const ErrorNotFound = () => {
  return (
    <div>
      <h1 className="text-xl">Error (404)</h1>
      <p>We can't find the page you're looking for.</p>
    </div>
  );
};
